var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputCompleteV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#37C17F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.77 6.38106L7.48591 10.7691C7.33258 10.9261 7.13416 11 6.92672 11C6.7283 11 6.52988 10.9261 6.37655 10.7691L4.22999 8.57968C3.92334 8.25635 3.92334 7.74827 4.22999 7.43418C4.53664 7.12009 5.04171 7.12009 5.34837 7.43418L6.92672 9.05081L10.6516 5.23557C10.9583 4.92148 11.4634 4.92148 11.77 5.23557C12.0767 5.55889 12.0767 6.06697 11.77 6.38106Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCompleteV);
export default __webpack_public_path__ + "static/media/input-complete-v.fe57e9257962f73d9f11f7d92847c29d.svg";
export { ForwardRef as ReactComponent };